import { BaseSportsSubscriber } from "../baseSportsSubscriber";
import { sportsbookConnectionHOF } from "../../sportsbookConnectionHOF";
export class SportsbookMarkets extends BaseSportsSubscriber {
    constructor(eventGroup, subCategoryId, page, initialData, onDataCallback, onErrorCallback) {
        super(onDataCallback, onErrorCallback);
        this.query = {
            name: this.getName(),
            params: {
                entity: "markets",
                queryParams: {
                    query: `$filter=leagueId eq '${eventGroup}' and clientMetadata/subCategoryId eq '${subCategoryId}' and tags/all(t: t ne 'SportcastBetBuilder')`,
                    initialData,
                    projection: "sportsbook",
                    locale: super.getLocale()
                },
                forwardedHeaders: {},
                clientMetadata: Object.assign({ feature: page }, this.clientMetadata),
            }
        };
    }
    onData(x) {
        super.onData(x);
    }
}
export const SportsbookMarketsHOF = sportsbookConnectionHOF(SportsbookMarkets, {}, false);
//# sourceMappingURL=SportsbookMarkets.js.map